import axios from "@/api/request"
import { plainToInstance } from 'class-transformer';
import { mybatisplusPage } from '@suc/nomos-lint';
import { Authoxuser } from './models/Authoxuser';
import { AuthoxObjectTreeVO } from './models/AuthoxObjectTreeVO';
import { AuthoxRole } from './models/AuthoxRole';
import { AuthoxRule } from './models/AuthoxRule';

/**
* @NomosController
* @NomosDefinePackageName com.sucsoft.organization.basic.management.server.controller
* @NomosDefineClassName AuthoxuserController
*/
export class AuthoxuserController {

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/change/pwd
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName changeCurrentUserPwd
     * @NomosDefineParameters [{"name":"uid","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null},{"name":"oldPwd","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null},{"name":"newPwd","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-14-修改当前登录用户密码"
     * @NomosDefinePathStyle NORMAL
     */
    changeCurrentUserPwd(params: { "uid": string, "oldPwd": string, "newPwd": string }) {
        const url = '/api/organization/management/server/authoxuser/change/pwd';
        return axios
            .get<void>(url, {params})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/current/user
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName queryCurrentUserDetail
     * @NomosDefineParameters []
     * @NomosDefineSuccessResponse com.sucsoft.organization.basic.management.commons.entity.Authoxuser
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-1-查询当前登录用户基本信息详情"
     * @NomosDefinePathStyle NORMAL
     */
    queryCurrentUserDetail() {
        const url = '/api/organization/management/server/authoxuser/current/user';
        return axios
            .get<any>(url, {})
            .then(({data}) => plainToInstance(Authoxuser, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/currentUser/uid
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName currentUserId
     * @NomosDefineParameters []
     * @NomosDefineSuccessResponse string
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-13-查询当前登录用户uid"
     * @NomosDefinePathStyle NORMAL
     */
    currentUserId() {
        const url = '/api/organization/management/server/authoxuser/currentUser/uid';
        return axios
            .get<string>(url, {})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/object/tree
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName queryAllObjectsTree
     * @NomosDefineParameters [{"name":"type","type":{"family":"string"},"required":false,"isRequestBody":false,"description":"权限类型(gov政府端/expert专家端/produce生产主体端)"}]
     * @NomosDefineSuccessResponse java.util.List<com.sucsoft.organization.basic.management.commons.vo.AuthoxObjectTreeVO>
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-7-查询所有权限-树"
     * @NomosDefinePathStyle NORMAL
     */
    queryAllObjectsTree(params: { "type"?: string }) {
        const url = '/api/organization/management/server/authoxuser/object/tree';
        return axios
            .get<any[]>(url, {params})
            .then(({data}) => plainToInstance(AuthoxObjectTreeVO, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod DELETE
     * @NomosDefineRequestType json
     * @NomosDefineMethodName removeByRole
     * @NomosDefineParameters [{"name":"role","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-11-删除角色"
     * @NomosDefinePathStyle NORMAL
     */
    removeByRole(role: string) {
        const url = '/api/organization/management/server/authoxuser';
        return axios
            .delete<void>(url, {params: {role}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/resetPwd/{id}
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName resetPasswordByAdmin
     * @NomosDefineParameters [{"name":"id","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-2-给指定用户重置密码"
     * @NomosDefinePathStyle NORMAL
     */
    resetPasswordByAdmin(id: string) {
        const url = `/api/organization/management/server/authoxuser/resetPwd/${id}`;
        return axios
            .get<void>(url, {params: {id}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role/add/users
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName addUsersRole
     * @NomosDefineParameters [{"name":"uids","type":{"family":"array","elementType":{"family":"string"}},"required":true,"isRequestBody":false,"description":"账号uids"},{"name":"role","type":{"family":"string"},"required":true,"isRequestBody":false,"description":"角色标识"},{"name":"type","type":{"family":"string"},"required":false,"isRequestBody":false,"description":"角色类型(gov政府端/expert专家端/produce生产主体端)"}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-16-角色批量匹配用户"
     * @NomosDefinePathStyle NORMAL
     */
    addUsersRole(params: { "uids": Array<string>, "role": string, "type"?: string }) {
        const url = '/api/organization/management/server/authoxuser/role/add/users';
        return axios
            .get<void>(url, {params})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role/list
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName queryAllRoles
     * @NomosDefineParameters [{"name":"type","type":{"family":"string"},"required":false,"isRequestBody":false,"description":"角色类型(gov政府端/expert专家端/produce生产主体端)"},{"name":"role","type":{"family":"string"},"required":false,"isRequestBody":false,"description":null},{"name":"name","type":{"family":"string"},"required":false,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse java.util.List<com.sucsoft.organization.basic.management.commons.entity.AuthoxRole>
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-8-查询所有角色信息"
     * @NomosDefinePathStyle NORMAL
     */
    queryAllRoles(params: { "type"?: string, "role"?: string, "name"?: string }) {
        const url = '/api/organization/management/server/authoxuser/role/list';
        return axios
            .get<any[]>(url, {params})
            .then(({data}) => plainToInstance(AuthoxRole, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName queryAuthorUserByRoleName
     * @NomosDefineParameters [{"name":"role","type":{"family":"string"},"required":true,"isRequestBody":false,"description":"角色标识"}]
     * @NomosDefineSuccessResponse java.util.List<com.sucsoft.organization.basic.management.commons.entity.Authoxuser>
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-4-查询角色下所有用户信息"
     * @NomosDefinePathStyle NORMAL
     */
    queryAuthorUserByRoleName(role: string) {
        const url = '/api/organization/management/server/authoxuser/role';
        return axios
            .get<any[]>(url, {params: {role}})
            .then(({data}) => plainToInstance(Authoxuser, data));
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role/save
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod POST
     * @NomosDefineRequestType json
     * @NomosDefineMethodName saveAuthoxRole
     * @NomosDefineParameters [{"name":"authoxRole","type":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.entity.AuthoxRole","elementTypes":[]},"required":true,"isRequestBody":true,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-9-新增角色"
     * @NomosDefinePathStyle NORMAL
     */
    saveAuthoxRole(authoxRole: AuthoxRole) {
        const url = '/api/organization/management/server/authoxuser/role/save';
        return axios
            .post<void>(url, authoxRole, {})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role/update
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod PUT
     * @NomosDefineRequestType json
     * @NomosDefineMethodName updateAuthoxRole
     * @NomosDefineParameters [{"name":"authoxRole","type":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.entity.AuthoxRole","elementTypes":[]},"required":true,"isRequestBody":true,"description":null}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-10-修改角色"
     * @NomosDefinePathStyle NORMAL
     */
    updateAuthoxRole(authoxRole: AuthoxRole) {
        const url = '/api/organization/management/server/authoxuser/role/update';
        return axios
            .put<void>(url, authoxRole, {})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/role/user
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName userRoles
     * @NomosDefineParameters [{"name":"uid","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse boolean
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-17-根据uid判断是否为管理员用户"
     * @NomosDefinePathStyle NORMAL
     */
    userRoles(uid: string) {
        const url = '/api/organization/management/server/authoxuser/role/user';
        return axios
            .get<boolean>(url, {params: {uid}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/roles/{role}/rules
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName getRules
     * @NomosDefineParameters [{"name":"role","type":{"family":"string"},"required":true,"isRequestBody":false,"description":"角色名称"}]
     * @NomosDefineSuccessResponse java.util.Set<com.cgs.authox.Rule>
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-5-查询角色对应的所有授权规则"
     * @NomosDefinePathStyle NORMAL
     */
    getRules(role: string) {
        const url = `/api/organization/management/server/authoxuser/roles/${role}/rules`;
        return axios
            .get<any[]>(url, {params: {role}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/roles/{role}/rules
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod POST
     * @NomosDefineRequestType json
     * @NomosDefineMethodName saveRules
     * @NomosDefineParameters [{"name":"role","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null},{"name":"rules","type":{"family":"array","elementType":{"family":"object","className":"com.sucsoft.organization.basic.management.commons.entity.AuthoxRule","elementTypes":[]}},"required":true,"isRequestBody":true,"description":null},{"name":"type","type":{"family":"string"},"required":true,"isRequestBody":false,"description":"权限类型(gov政府端/expert专家端/produce生产主体端)"}]
     * @NomosDefineSuccessResponse void
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-6-角色批量添加授权"
     * @NomosDefinePathStyle NORMAL
     */
    saveRules(role: string, type: string, rules: Array<AuthoxRule>) {
        const url = `/api/organization/management/server/authoxuser/roles/${role}/rules`;
        return axios
            .post<void>(url, rules, {params: {role, type}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/rules/{uid}
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName queryRulesByUid
     * @NomosDefineParameters [{"name":"uid","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse java.util.List<java.util.Map<string, string>>
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-3-查询用户权限规则"
     * @NomosDefinePathStyle NORMAL
     */
    queryRulesByUid(uid: string) {
        const url = `/api/organization/management/server/authoxuser/rules/${uid}`;
        return axios
            .get<Array<Record<string, string>>>(url, {params: {uid}})
            .then(({data}) => data);
    }

    /**
     * @NomosDefinePath /api/organization/management/server/authoxuser/{uid}
     * @NomosDefinePathActions []
     * @NomosDefineRequestMethod GET
     * @NomosDefineRequestType json
     * @NomosDefineMethodName getUser
     * @NomosDefineParameters [{"name":"uid","type":{"family":"string"},"required":true,"isRequestBody":false,"description":null}]
     * @NomosDefineSuccessResponse com.sucsoft.organization.basic.management.commons.entity.Authoxuser
     * @NomosDefineDescription "[组织管理-人员账号相关信息]API-12-查询用户对应账号信息详情"
     * @NomosDefinePathStyle NORMAL
     */
    getUser(uid: string) {
        const url = `/api/organization/management/server/authoxuser/${uid}`;
        return axios
            .get<any>(url, {params: {uid}})
            .then(({data}) => plainToInstance(Authoxuser, data));
    }

}

export const authoxuserController = new AuthoxuserController();
